export const getApiPrefix = () => 'gateway/api/jira/project-configuration';
